module.exports = __webpack_public_path__ + "img/CARA_COVER.8586c776.jpg";